// 详情模块

const Doc = {
  namespaced: true,

  state: {
    docid: '',
    uploadLeavePage: 0
  },
  mutations: {
    SET_DOC_ID: (state, value) => {
      state.docid = value
    },
    SET_DOC_CURRENTPAGE: (state, value) => {
      state.uploadLeavePage = value
    }
  },
  actions: {}
}

export default Doc
